var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('b-spinner',{attrs:{"label":"Loading..."}}),_c('p',[_vm._v("Aguarde, efetuando login")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }